import { InjectionToken } from '@angular/core';

/**
 * Una memoria EN MEMORIA de la pestaña que pertenece al usuario (no a la sesión del
 * storage) y que `LogoutService.forgetTabMemory()` tiene que vaciar al cerrar sesión y
 * al iniciar un login: el logout navega sin recargar, así que los singletons raíz
 * sobreviven al siguiente usuario de la pestaña.
 */
export interface TabMemory {
  clear(): void;
}

/**
 * Las memorias que viven en features (TPV, E-commerce) se registran aquí, `multi` y con
 * `useExisting`, SOLO en `app.config.ts`. `LogoutService` las pide al vaciar —no al
 * construirse—: así no instancia servicios de feature en el login ni exige sus
 * enlaces en cada spec que lo use.
 */
export const TAB_MEMORIES = new InjectionToken<readonly TabMemory[]>('TAB_MEMORIES');
